import { render } from "./InfoMessages.vue?vue&type=template&id=05b11a32&ts=true"
import script from "./InfoMessages.vue?vue&type=script&lang=ts"
export * from "./InfoMessages.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__